export default "__VITE_ASSET__40c2c535__"